import { render, staticRenderFns } from "./sidebar-layout.vue?vue&type=template&id=c3794062"
import script from "./sidebar-layout.ts?vue&type=script&lang=js&external"
export * from "./sidebar-layout.ts?vue&type=script&lang=js&external"
import style0 from "./sidebar-layout.vue?vue&type=style&index=0&id=c3794062&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports